import { capitalize } from 'lodash';
import { useEffect, useMemo, useRef, useState } from 'react';
import Fullscreenable from '../ui/Fullscreenable';
import htmlStringToReactNodes from '../../helpers/htmlStringToReactNodes';
import withAppOrigin, { appEnvName } from '../../helpers/withAppOrigin';
import { useSession } from '../../lib/hooks';
import styles from './ModulePreview.module.scss';
const _ModulePreview = ({
  url,
  cover,
  onComplete
}) => {
  const iframeRef = useRef();
  const {
    user
  } = useSession();
  const [showRetry, setShowRetry] = useState(false);
  const src = useMemo(() => {
    if (!(user && url)) {
      return null;
    }
    const srcURL = withAppOrigin(url);
    srcURL.searchParams.set('bookmarks', false);
    srcURL.searchParams.set('reporting', true);
    const intent_url = srcURL.searchParams.get('intent_url');
    if (intent_url) {
      const intent = new URL(intent_url);
      intent.searchParams.set('userId', user.id);
      intent.searchParams.set('userType', 'Student');
      const appEnv = appEnvName();
      if (appEnv) {
        intent.searchParams.set('_bookbuddies_env', appEnv);
      }
      srcURL.searchParams.set('intent_url', intent.href);
    } else {
      srcURL.searchParams.set('userId', user.id);
      srcURL.searchParams.set('userType', 'Student');
    }
    return srcURL.href;
  }, [user, url]);
  const [moduleLang, setModuleLang] = useState(() => url && new URL(url).searchParams.get('language') || 'en');
  useEffect(() => {
    if (!src) {
      return;
    }
    const expectedOrigin = new URL(src).origin;
    const handler = ({
      data,
      origin,
      source
    }) => {
      if (expectedOrigin !== origin) {
        return;
      }
      if (iframeRef.current?.contentWindow !== source) {
        return;
      }
      if (['logout', 'exitPreview'].includes(data.event)) {
        setShowRetry(true);
        onComplete && onComplete();
      }
      if (['open'].includes(data.event)) {
        window.open(data.args[0]);
      }
      if (['languageChange'].includes(data.event)) {
        setModuleLang(data.args[0]);
      }
    };
    window.addEventListener('message', handler);
    return () => window.removeEventListener('message', handler);
  }, [src, onComplete, setModuleLang]);
  return <Fullscreenable data-sentry-element="Fullscreenable" data-sentry-component="_ModulePreview" data-sentry-source-file="ModulePreview.jsx">
      <div className={styles["module-preview"]}>
        {src ? showRetry ? <div className={styles.retry}>
              <img src={`/assets/activity_preview_retry_btn_${moduleLang}.png`} alt="replay activity" style={{
          maxWidth: 'min(calc(4/3*100cqh), 100%)'
        }} />
              <button aria-label="replay" onClick={() => setShowRetry(false)} style={{
          maxWidth: 'min(calc(4/3*18cqh), 18%)',
          right: 'calc(50% - min(calc(4/3*30cqh), 30%))'
        }} />
            </div> : <iframe ref={iframeRef} key={src} src={src} allow="microphone; autoplay" style={{
        width: '100%',
        height: '100%',
        border: 0
      }} /> : cover}
      </div>
    </Fullscreenable>;
};
export const ModulePreview = props => <_ModulePreview {...props} key={props.url} data-sentry-element="_ModulePreview" data-sentry-component="ModulePreview" data-sentry-source-file="ModulePreview.jsx" />;
export const ModulePreviewNavigation = ({
  title,
  activities,
  step,
  updateStep,
  parentLanguage
}) => <div className={styles["module-navigation-container"]} data-sentry-component="ModulePreviewNavigation" data-sentry-source-file="ModulePreview.jsx">
    <div className={styles["activity-info"]}>
      <div className={styles["activity-list-header"]}>
        <div className={styles.title}>{title}</div>
      </div>
      <div className={styles["activity-list-container"]}>
        <ul className={styles["activity-list"]}>
          {activities.map((activity, index) => {
          const language = activity.language.split('_').includes(parentLanguage) ? parentLanguage : activity.language;
          return <li className={`${styles['activity-list-item']} ${step === index && styles.current}`} key={activity.slug} onClick={() => updateStep(index)}>
                <div className={styles["activity-list-thumbnail"]}>
                  <img src={language === 'es' ? activity.spanishImageURL : activity.imageURL} alt={language === 'es' ? activity.spanishName : activity.name} />
                </div>
                <div className={styles["activity-list-text"]}>
                  <div className={styles["activity-list-title"]}>{language === 'es' ? activity.spanishName : activity.name}</div>
                  <div className={styles["activity-list-objective"]}>{htmlStringToReactNodes(language === 'es' ? activity.spanishLearningObjectiveHTML : activity.learningObjectiveHTML)}</div>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </div>
  </div>;